export const config = {
  rowSelection: true,
  columns: [
    {title: '机构编码  ', dataIndex: 'institutionNumber', width: 100},
    {title: '机构名称', dataIndex: 'institutionName', width: 200, ellipsis: true},
    {title: '纳税人识别号', dataIndex: 'taxNumber', width: 180, ellipsis: true},
    {title: '开户行名称', dataIndex: 'accountName', width: 180, ellipsis: true},
    {title: '开户行网点', dataIndex: 'bankBranches', width: 180, ellipsis: true},
    {title: '银行账号', dataIndex: 'accountNo', width: 180, ellipsis: true},
    {title: '状态', dataIndex: 'enabled', width: 100, render: 'enabledName'},
    {title: '创建人', dataIndex: 'createdByName', width: 100, ellipsis: true},
    {title: '修改人', dataIndex: 'modifiedByName', width: 100, ellipsis: true},
    {title: '创建时间', dataIndex: 'createdTime', width: 180, itemType: 'dateTime'},
    {title: '操作', dataIndex: '#', width: 160, fixed: 'right', render: 'actionRender'},
  ],
  search: [
    {label: '机构名称', name: 'institutionName'},
  ],
  footer: [
    {label: '新增', type: 'primary', events: ['onClick:onAdd']},
  ],
  batchActions: [
    {
      label: '启用',
      type: 'primary',
      events: ['onClick:onEnables'],
      disabled: 'btnDisabled'
    },
    {
      label: '禁用',
      type: 'primary',
      events: ['onClick:onDisables'],
      disabled: 'btnDisabled'
    }
  ]
}
 